import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import { Turbo } from "@hotwired/turbo-rails"
import "./confirmations"

import jquery from "jquery"
window.$ = jquery
window.jQuery = jquery

await import("@nathanvda/cocoon")

import { Application } from "@hotwired/stimulus"
import { definitions } from "stimulus:./controllers"

const app = Application.start();
app.load(definitions);

Turbo.session.drive = false

document.addEventListener("turbo:before-fetch-request", (event) => {
    const token = document.querySelector("meta[name='csrf-token']")?.content
    if (token) {
        event.detail.fetchOptions.headers["X-CSRF-Token"] = token
    }
})
